export const loginResponseObj = {
  id: '606c879c-7993-456fa58c-933b199d4d11',
  username: 'matt@greensunmedical.com',
  email: 'matt@greensunmedical.com',
  clinics: [
    { id: 10, name: 'Green Sun Clinic' },
    { id: 14, name: 'Green Sun Clinic 1' },
  ],
  picture: '',
  roles: ['PATIENT', 'PROVIDER'],
  customer_id: '90b4725d-930d-41b0-93725d056981f526',
  terms_and_conditions: true,
  email_confirmed: false,
  first_name: null,
  last_name: null,
  primary_language: null,
};

export const transfers = [
  {
    id: 984,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1560,
    created_at: '2021-01-24T16:48:31.586Z',
    updated_at: null,
  },
  {
    id: 979,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1560,
    created_at: '2021-01-21T20:58:36.103Z',
    updated_at: null,
  },
  {
    id: 978,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1560,
    created_at: '2021-01-21T20:58:12.535Z',
    updated_at: null,
  },
  {
    id: 955,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 5017,
    created_at: '2021-01-14T20:50:13.912Z',
    updated_at: null,
  },
  {
    id: 901,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 10340,
    created_at: '2021-01-07T01:27:30.964Z',
    updated_at: null,
  },
  {
    id: 894,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 144,
    created_at: '2021-01-01T03:50:59.325Z',
    updated_at: null,
  },
  {
    id: 893,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 221,
    created_at: '2020-12-30T22:33:39.260Z',
    updated_at: null,
  },
  {
    id: 892,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1285,
    created_at: '2020-12-29T22:56:14.040Z',
    updated_at: null,
  },
  {
    id: 891,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1284,
    created_at: '2020-12-29T22:55:59.266Z',
    updated_at: null,
  },
  {
    id: 888,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1284,
    created_at: '2020-12-26T22:19:23.484Z',
    updated_at: null,
  },
  {
    id: 887,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3012,
    created_at: '2020-12-26T06:32:13.213Z',
    updated_at: null,
  },
  {
    id: 883,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3819,
    created_at: '2020-12-24T05:03:01.529Z',
    updated_at: null,
  },
  {
    id: 881,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3467,
    created_at: '2020-12-23T00:08:38.107Z',
    updated_at: null,
  },
  {
    id: 879,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1510,
    created_at: '2020-12-21T20:59:06.979Z',
    updated_at: null,
  },
  {
    id: 878,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 363,
    created_at: '2020-12-21T05:02:47.935Z',
    updated_at: null,
  },
  {
    id: 877,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2047,
    created_at: '2020-12-21T04:25:23.563Z',
    updated_at: null,
  },
  {
    id: 875,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1740,
    created_at: '2020-12-20T01:51:57.943Z',
    updated_at: null,
  },
  {
    id: 874,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1626,
    created_at: '2020-12-19T03:17:13.185Z',
    updated_at: null,
  },
  {
    id: 873,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1512,
    created_at: '2020-12-19T01:41:58.851Z',
    updated_at: null,
  },
  {
    id: 872,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1512,
    created_at: '2020-12-19T01:36:41.684Z',
    updated_at: null,
  },
  {
    id: 871,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1512,
    created_at: '2020-12-18T04:35:22.834Z',
    updated_at: null,
  },
  {
    id: 870,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1512,
    created_at: '2020-12-18T03:59:53.798Z',
    updated_at: null,
  },
  {
    id: 869,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1512,
    created_at: '2020-12-18T03:59:31.170Z',
    updated_at: null,
  },
  {
    id: 866,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3241,
    created_at: '2020-12-17T04:24:10.696Z',
    updated_at: null,
  },
  {
    id: 862,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3369,
    created_at: '2020-12-14T22:47:41.760Z',
    updated_at: null,
  },
  {
    id: 861,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3448,
    created_at: '2020-12-13T23:53:34.147Z',
    updated_at: null,
  },
  {
    id: 857,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1739,
    created_at: '2020-12-13T00:09:53.726Z',
    updated_at: null,
  },
  {
    id: 855,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 375,
    created_at: '2020-12-12T05:12:48.034Z',
    updated_at: null,
  },
  {
    id: 854,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1775,
    created_at: '2020-12-12T00:39:41.293Z',
    updated_at: null,
  },
  {
    id: 851,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1970,
    created_at: '2020-12-11T03:21:44.040Z',
    updated_at: null,
  },
  {
    id: 850,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2053,
    created_at: '2020-12-10T04:30:56.022Z',
    updated_at: null,
  },
  {
    id: 848,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2998,
    created_at: '2020-12-09T17:38:26.207Z',
    updated_at: null,
  },
  {
    id: 845,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1499,
    created_at: '2020-12-08T20:49:49.488Z',
    updated_at: null,
  },
  {
    id: 844,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 447,
    created_at: '2020-12-08T06:12:30.238Z',
    updated_at: null,
  },
  {
    id: 842,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1781,
    created_at: '2020-12-08T00:44:39.485Z',
    updated_at: null,
  },
  {
    id: 840,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1872,
    created_at: '2020-12-07T18:40:10.955Z',
    updated_at: null,
  },
  {
    id: 837,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 303,
    created_at: '2020-12-06T19:23:34.604Z',
    updated_at: null,
  },
  {
    id: 836,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 108,
    created_at: '2020-12-06T16:40:27.019Z',
    updated_at: null,
  },
  {
    id: 834,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1448,
    created_at: '2020-12-06T01:22:56.085Z',
    updated_at: null,
  },
  {
    id: 833,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3048,
    created_at: '2020-12-05T23:35:47.074Z',
    updated_at: null,
  },
  {
    id: 821,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2264,
    created_at: '2020-12-03T08:54:05.491Z',
    updated_at: null,
  },
  {
    id: 818,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1428,
    created_at: '2020-12-02T21:16:34.055Z',
    updated_at: null,
  },
  {
    id: 812,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 872,
    created_at: '2020-12-02T13:33:31.988Z',
    updated_at: null,
  },
  {
    id: 810,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 102,
    created_at: '2020-12-02T02:45:00.129Z',
    updated_at: null,
  },
  {
    id: 809,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 9,
    created_at: '2020-12-02T01:26:55.848Z',
    updated_at: null,
  },
  {
    id: 808,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 597,
    created_at: '2020-12-02T01:26:42.327Z',
    updated_at: null,
  },
  {
    id: 807,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 588,
    created_at: '2020-12-01T21:52:13.207Z',
    updated_at: null,
  },
  {
    id: 782,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2095,
    created_at: '2020-11-23T05:06:06.087Z',
    updated_at: null,
  },
  {
    id: 776,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1312,
    created_at: '2020-11-22T18:13:55.532Z',
    updated_at: null,
  },
  {
    id: 775,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2063,
    created_at: '2020-11-22T04:39:00.135Z',
    updated_at: null,
  },
  {
    id: 771,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1728,
    created_at: '2020-11-21T23:59:58.831Z',
    updated_at: null,
  },
  {
    id: 766,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 3813,
    created_at: '2020-11-21T04:57:12.020Z',
    updated_at: null,
  },
  {
    id: 751,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2099,
    created_at: '2020-11-19T05:09:52.220Z',
    updated_at: null,
  },
  {
    id: 742,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1666,
    created_at: '2020-11-18T23:08:22.031Z',
    updated_at: null,
  },
  {
    id: 739,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1346,
    created_at: '2020-11-18T18:41:51.922Z',
    updated_at: null,
  },
  {
    id: 735,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1133,
    created_at: '2020-11-18T15:44:55.934Z',
    updated_at: null,
  },
  {
    id: 733,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 333,
    created_at: '2020-11-18T04:37:33.334Z',
    updated_at: null,
  },
  {
    id: 732,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1973,
    created_at: '2020-11-18T03:24:12.551Z',
    updated_at: null,
  },
  {
    id: 724,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 99,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1501,
    created_at: '2020-11-17T20:51:07.211Z',
    updated_at: null,
  },
  {
    id: 718,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1904,
    created_at: '2020-11-17T02:26:17.025Z',
    updated_at: null,
  },
  {
    id: 712,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 2122,
    created_at: '2020-11-16T05:29:00.332Z',
    updated_at: null,
  },
  {
    id: 710,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1695,
    created_at: '2020-11-15T23:32:54.370Z',
    updated_at: null,
  },
  {
    id: 709,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 507,
    created_at: '2020-11-15T07:02:31.344Z',
    updated_at: null,
  },
  {
    id: 707,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1771,
    created_at: '2020-11-15T00:35:49.801Z',
    updated_at: null,
  },
  {
    id: 706,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1376,
    created_at: '2020-11-14T19:06:43.849Z',
    updated_at: null,
  },
  {
    id: 703,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1268,
    created_at: '2020-11-14T17:36:17.888Z',
    updated_at: null,
  },
  {
    id: 701,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 1034,
    created_at: '2020-11-14T14:21:55.059Z',
    updated_at: null,
  },
  {
    id: 700,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 335,
    created_at: '2020-11-14T04:39:30.977Z',
    updated_at: null,
  },
  {
    id: 699,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 173,
    created_at: '2020-11-14T02:24:57.092Z',
    updated_at: null,
  },
  {
    id: 698,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 320,
    created_at: '2020-11-14T00:25:38.233Z',
    updated_at: null,
  },
  {
    id: 696,
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    battery: 100,
    firmware: '0.8.1_9c7667b1',
    journal_version: null,
    app_version: '1.9.0',
    os: 'ios',
    serial: 'b110d48cfc274f29',
    record_count: 24,
    created_at: '2020-11-13T20:19:09.633Z',
    updated_at: null,
  },
];

export const patientsList = [
  {
    user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
    status: 'Active',
    email: 'devmgilroy@gmail.com',
    picture: '',
    first_name: 'Devin ',
    last_name: 'Gilroy ',
    birth_date: '2008-07-23T16:43:00.000Z',
    sex: 'FEMALE',
    primary_insurance_name: null,
    secondary_insurance_name: null,
    providers: [null, null, null, null, null, null],
    cobb_serial_number: '',
    compliance_hours: '8',
    cpab: [
      {
        duration: 1211040,
        activity_type: 2,
        user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
        bucket: 'month',
        oldest: '2022-02-13T10:22:00+00:00',
      },
      {
        duration: 14880,
        activity_type: 0,
        user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
        bucket: 'week',
        oldest: '2022-03-08T11:29:00+00:00',
      },
      {
        duration: 518760,
        activity_type: 2,
        user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
        bucket: 'week',
        oldest: '2022-03-08T10:22:00+00:00',
      },
      {
        duration: 2867880,
        activity_type: 2,
        user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
        bucket: 'year',
        oldest: '2021-09-21T22:24:00+00:00',
      },
      {
        duration: 22080,
        activity_type: 0,
        user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
        bucket: 'month',
        oldest: '2022-02-13T13:00:00+00:00',
      },
      {
        duration: 37500,
        activity_type: 0,
        user_id: '2c897bb9-8d8e-4ff9-997c-d25550446194',
        bucket: 'year',
        oldest: '2021-09-22T22:42:00+00:00',
      },
    ],
  },
  {
    user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
    status: 'Active',
    email: 'suedauctuk@gmail.com',
    picture: '',
    first_name: 'Sueda',
    last_name: 'Uctuk',
    birth_date: '2007-10-01T22:17:00.000Z',
    sex: 'FEMALE',
    primary_insurance_name: null,
    secondary_insurance_name: null,
    providers: [null, null, null, null, null, null],
    cobb_serial_number: '',
    compliance_hours: '18',
    cpab: [
      {
        duration: 1020,
        activity_type: 0,
        user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
        bucket: 'week',
        oldest: '2022-03-09T00:45:00+00:00',
      },
      {
        duration: 541740,
        activity_type: 2,
        user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
        bucket: 'week',
        oldest: '2022-03-08T10:22:00+00:00',
      },
      {
        duration: 9120,
        activity_type: 0,
        user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
        bucket: 'month',
        oldest: '2022-02-14T01:51:00+00:00',
      },
      {
        duration: 21600,
        activity_type: 0,
        user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
        bucket: 'year',
        oldest: '2021-12-22T02:17:00+00:00',
      },
      {
        duration: 2501700,
        activity_type: 2,
        user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
        bucket: 'month',
        oldest: '2022-02-13T10:22:00+00:00',
      },
      {
        duration: 6174780,
        activity_type: 2,
        user_id: 'd2b7f74e-c609-492a-9c14-3b6d6e09de73',
        bucket: 'year',
        oldest: '2021-12-20T21:14:00+00:00',
      },
    ],
  },
  {
    user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
    status: 'InActive',
    email: 'fmichaelroberts@gmail.com',
    picture: '',
    first_name: 'Kieran',
    last_name: 'Roberts',
    birth_date: '2010-09-29T21:59:00.000Z',
    sex: 'MALE',
    primary_insurance_name: null,
    secondary_insurance_name: null,
    providers: [null, null, null, null, null, null],
    cobb_serial_number: '',
    compliance_hours: '18',
    cpab: [
      {
        duration: 2482860,
        activity_type: 2,
        user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
        bucket: 'month',
        oldest: '2022-02-13T10:22:00+00:00',
      },
      {
        duration: 55620,
        activity_type: 0,
        user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
        bucket: 'year',
        oldest: '2022-01-25T05:30:00+00:00',
      },
      {
        duration: 5100,
        activity_type: 0,
        user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
        bucket: 'week',
        oldest: '2022-03-08T16:42:00+00:00',
      },
      {
        duration: 3917580,
        activity_type: 2,
        user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
        bucket: 'year',
        oldest: '2022-01-24T23:02:00+00:00',
      },
      {
        duration: 537360,
        activity_type: 2,
        user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
        bucket: 'week',
        oldest: '2022-03-08T10:22:00+00:00',
      },
      {
        duration: 17460,
        activity_type: 0,
        user_id: 'a77ab0a2-9a8b-4091-8fb0-443e5918496a',
        bucket: 'month',
        oldest: '2022-02-13T20:04:00+00:00',
      },
    ],
  },
  {
    user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
    status: 'Active',
    email: '003006@greensunmedical.com',
    picture: '',
    first_name: '003006',
    last_name: 'St.Louis',
    birth_date: '2020-08-24T19:07:19.379Z',
    sex: 'FEMALE',
    primary_insurance_name: null,
    secondary_insurance_name: null,
    providers: [null, null, null, null, null, null],
    cobb_serial_number: '',
    compliance_hours: '18',
    cpab: [
      {
        duration: 1723380,
        activity_type: 2,
        user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
        bucket: 'month',
        oldest: '2022-02-14T04:55:00+00:00',
      },
      {
        duration: 372840,
        activity_type: 2,
        user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
        bucket: 'week',
        oldest: '2022-03-09T03:48:00+00:00',
      },
      {
        duration: 18171120,
        activity_type: 2,
        user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
        bucket: 'year',
        oldest: '2021-03-15T10:22:00+00:00',
      },
      {
        duration: 254700,
        activity_type: 0,
        user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
        bucket: 'month',
        oldest: '2022-02-14T04:58:00+00:00',
      },
      {
        duration: 1416660,
        activity_type: 0,
        user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
        bucket: 'year',
        oldest: '2021-03-15T14:02:00+00:00',
      },
      {
        duration: 56220,
        activity_type: 0,
        user_id: '3f883d1e-1824-41ca-9813-f25ab4fc4764',
        bucket: 'week',
        oldest: '2022-03-09T08:50:00+00:00',
      },
    ],
  },
  {
    user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
    status: 'Active',
    email: 'avik@efcom.co.il',
    picture: '',
    first_name: 'avi',
    last_name: 'efcom',
    birth_date: '2021-07-07T17:25:55.685Z',
    sex: 'MALE',
    primary_insurance_name: null,
    secondary_insurance_name: null,
    providers: [null, null, null, null, null, null],
    cobb_serial_number: null,
    compliance_hours: null,
    cpab: [
      {
        duration: 150300,
        activity_type: 0,
        user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
        bucket: 'year',
        oldest: '2021-07-19T12:57:00+00:00',
      },
      {
        duration: 436020,
        activity_type: 2,
        user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
        bucket: 'month',
        oldest: '2022-03-01T03:36:00+00:00',
      },
      {
        duration: 1200,
        activity_type: 0,
        user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
        bucket: 'week',
        oldest: '2022-03-08T19:50:00+00:00',
      },
      {
        duration: 124980,
        activity_type: 0,
        user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
        bucket: 'month',
        oldest: '2022-03-01T03:37:00+00:00',
      },
      {
        duration: 1500,
        activity_type: 2,
        user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
        bucket: 'week',
        oldest: '2022-03-08T19:51:00+00:00',
      },
      {
        duration: 1500900,
        activity_type: 2,
        user_id: '5a6a15d2-9b6e-4e0c-aa6b-b5ed0eea3ac8',
        bucket: 'year',
        oldest: '2021-07-19T08:06:00+00:00',
      },
    ],
  },
];

export const me = {
  id: '606c879c-7993-456f-a58c-933b199d4d11',
  username: 'matt@greensunmedical.com',
  email: 'matt@greensunmedical.com',
  clinics: [
    {
      id: 10,
      name: 'Green Sun Clinic',
    },
    {
      id: 14,
      name: 'Green Sun Clinic 1',
    },
  ],
  picture: '',
  roles: ['PATIENT', 'PROVIDER'],
  customer_id: '90b4725d-930d-41b0-9372-5d056981f526',
  terms_and_conditions: true,
  email_confirmed: false,
  first_name: null,
  last_name: null,
  primary_language: null,
};

export const compilanceList = [
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 241,
    day: '2021-01-09T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 72300,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 169,
    day: '2021-01-08T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 50700,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 235,
    day: '2021-01-07T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 70500,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 238,
    day: '2021-01-06T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 71400,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 234,
    day: '2021-01-05T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 70200,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 227,
    day: '2021-01-04T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 68100,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 222,
    day: '2021-01-03T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 66600,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 242,
    day: '2021-01-02T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 72600,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 201,
    day: '2021-01-01T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 60300,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 36,
    day: '2020-12-30T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 10800,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 226,
    day: '2020-12-25T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 67800,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 223,
    day: '2020-12-24T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 66900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 244,
    day: '2020-12-23T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 73200,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 233,
    day: '2020-12-22T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 69900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 251,
    day: '2020-12-21T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 75300,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 183,
    day: '2020-12-20T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 54900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 232,
    day: '2020-12-19T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 69600,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 277,
    day: '2020-12-15T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 83100,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 184,
    day: '2020-12-14T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 55200,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 233,
    day: '2020-12-13T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 69900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 264,
    day: '2020-12-12T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 79200,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 277,
    day: '2020-12-11T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 83100,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 216,
    day: '2020-12-10T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 64800,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 204,
    day: '2020-12-09T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 61200,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 223,
    day: '2020-12-08T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 66900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 248,
    day: '2020-12-07T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 74400,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 54,
    day: '2020-12-06T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 16200,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 192,
    day: '2020-12-04T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 57600,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 238,
    day: '2020-12-03T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 71400,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 245,
    day: '2020-12-02T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 73500,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 110,
    day: '2020-11-23T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 33000,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 205,
    day: '2020-11-22T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 61500,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 263,
    day: '2020-11-21T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 78900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 260,
    day: '2020-11-20T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 78000,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 223,
    day: '2020-11-19T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 66900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 196,
    day: '2020-11-18T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 58800,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 260,
    day: '2020-11-17T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 78000,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 235,
    day: '2020-11-16T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 70500,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 223,
    day: '2020-11-15T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 66900,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 256,
    day: '2020-11-14T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 76800,
    activity_type: 2,
  },
  {
    user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
    count: 22,
    day: '2020-11-13T00:00:00.000Z',
    total_step_count: 0,
    total_interval: 6600,
    activity_type: 2,
  },
];

export const settings = {
  user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
  serial_number: 'b110d48cfc274f29',
  compliance_hours: '18',
};

export const personalInfo = {
  id: 15484,
  user_id: '01132ad4-a400-42d4-97a9-16337c68b392',
  first_name: '04001',
  last_name: 'Atlanta',
  dl_number: '',
  patient_number: '',
  ssn: '',
  marital_status: null,
  sex: 'FEMALE',
  height: '',
  weight: '',
  primary_language: 'en',
  birth_date: '2016-07-13T18:48:42.000Z',
};

export const curves = [];
export const roles = {
  Administrator: 'Administrator',
  HealthCareProvider: 'HealthCareProvider',
  Patient: 'Patient',
  Family: 'Family',
};

export const roleTypes = {
  Administrator: 'Administrator',
  User: 'User',
};
export const clinicStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
};
export const AdminAccessRole = {
  Grant: 'Grant',
  Remove: 'Remove',
};
export const patientStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  AdvancedToSurgery: 'AdvancedToSurgery',
  CompletedTreatmentSuccessfully: 'CompletedTreatmentSuccessfully',
};
export const urls = {
  clinics: '/admin-clinic',
  clinicDetails: '/clinic-details',
  userDetails: '/user-details',
  admins: '/admin-admins',
  users: '/admin-users',
  clinicUsers: '/clinic-users',
  patients: '/admin-paitents',
  clinicPatients: '/clinic-patients',
  nonClinicPaitents: '/non-clinic-paitents',
  patientDetails: '/patient-details',
  patientSettings: '/patient-settings',
  patientTransfers: '/patient-transfers',
  patientStatus: '/patient-status',
  paitentWellcome: '/patient-wellcome',
  activatePaitent: '/activate-paitent',
  resetPassword: '/reset-password',
  forgot: '/forgot',
  logout: '/logout',
  register: '/register',
  sorry: '/sorry',
  patientGoal: '/patient-goal',
};

export const headerEntity = {
  Clinic: 'Clinic',
  User: 'User',
};

export const userTableFields = [
  {
    name: 'image',
    textName: 'Image',
    canBeSorted: false,
  },
  {
    name: 'lastName',
    textName: 'Last Name',
    canBeSorted: true,
  },
  {
    name: 'firstName',
    textName: 'First Name',
    canBeSorted: true,
  },
  {
    name: 'email',
    textName: 'Email',
    canBeSorted: true,
  },
  {
    name: 'status',
    textName: 'Status',
    canBeSorted: true,
  },
  {
    name: 'roleID',
    textName: 'Role',
    canBeSorted: false,
  },
  {
    name: 'details',
    textName: 'Details',
    canBeSorted: false,
  },
  {
    name: 'clinicName',
    textName: 'Clinic Name',
    canBeSorted: false,
  },
  {
    name: 'remove',
    textName: 'Remove',
    canBeSorted: false,
  },
];

export const adminTableFields = [
  {
    name: 'image',
    textName: 'Image',
    canBeSorted: false,
  },
  {
    name: 'lastName',
    textName: 'Last Name',
    canBeSorted: true,
  },
  {
    name: 'firstName',
    textName: 'First Name',
    canBeSorted: true,
  },
  {
    name: 'email',
    textName: 'Email',
    canBeSorted: true,
  },
  {
    name: 'status',
    textName: 'Status',
    canBeSorted: true,
  },
  {
    name: 'details',
    textName: 'Details',
    canBeSorted: false,
  },
  {
    name: 'remove',
    textName: 'Remove',
    canBeSorted: false,
  },
];

export const patientTableFields = [
  {
    name: 'image',
    textName: 'Image',
    canBeSorted: false,
  },
  {
    name: 'lastName',
    textName: 'Last Name',
    canBeSorted: true,
  },
  {
    name: 'firstName',
    textName: 'First Name',
    canBeSorted: true,
  },
  {
    name: 'email',
    textName: 'Email',
    canBeSorted: true,
  },
  {
    name: 'goal',
    textName: 'Goal',
    canBeSorted: true,
  },
  {
    name: 'compliance',
    textName: 'Compliance',
    canBeSorted: false,
  },
  {
    name: 'status',
    textName: 'Status',
    canBeSorted: false,
  },

  {
    name: 'clinics',
    textName: 'Clinics',
    canBeSorted: true,
  },
  {
    name: 'details',
    textName: 'Details',
    canBeSorted: false,
  },
];
export const clinicTableFields = [
  {
    name: 'image',
    textName: 'Image',
    canBeSorted: false,
  },
  {
    name: 'name',
    textName: 'Name',
    canBeSorted: true,
  },
  {
    name: 'location',
    textName: 'Location',
    canBeSorted: true,
  },
  {
    name: 'email',
    textName: 'Email',
    canBeSorted: true,
  },
  {
    name: 'status',
    textName: 'Status',
    canBeSorted: true,
  },
  {
    name: 'details',
    textName: 'Destails',
    canBeSorted: false,
  },
  {
    name: 'users',
    textName: 'Users',
    canBeSorted: false,
  },
  {
    name: 'patients',
    textName: 'Patients',
    canBeSorted: false,
  },
  {
    name: 'remove',
    textName: 'Remove',
    canBeSorted: false,
  },
];

export const modalNames = {
  removeUser: 'removeUser',
  removeClinic: 'removeClinic',
  Diagnosis: 'Diagnosis',
};
